import { render } from "./TheFooter.vue?vue&type=template&id=4da5da9a&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=4da5da9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4da5da9a"

export default script